
import React, { PureComponent } from "react";
import { Button, Panel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SmoothCollapse from "react-smooth-collapse";
import _ from "lodash";
import Glyphicon from "../app-icon";
import ErrorBoundary from "../errors/errorBoundary";

export class AmbifiBasicPanel extends PureComponent {
	constructor(props) {
		super(props);

		let parentExpanded = true;
		if (this.props.hasOwnProperty("collapsed") && this.props.collapsed) {
			parentExpanded = false;
		}

		this.state = {
			expanded: parentExpanded,
			hasEverExpanded: parentExpanded
		};

		this.handleToggle = this.handleToggle.bind(this);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.collapsed !== this.props.collapsed) {
			this.setState({
				expanded: !nextProps.collapsed,
				hasEverExpanded: this.state.hasEverExpanded || !nextProps.collapsed
			});
		} else if (!nextProps.collapsed && nextProps.expandToken && nextProps.expandToken !== this.props.expandToken) {
			this.setState({
				expanded: true,
				hasEverExpanded: true
			});
		}
	}

	handleToggle(e) {
		const nextExpanded = !this.state.expanded;
		this.setState((prevState) => ({
			expanded: nextExpanded,
			hasEverExpanded: prevState.hasEverExpanded || nextExpanded
		}));

		if (this.props.onToggle) {
			this.props.onToggle(nextExpanded, e);
		}
		if (nextExpanded && this.props.onExpand) {
			this.props.onExpand(e);
		}
		if (!nextExpanded && this.props.onCollapse) {
			this.props.onCollapse(e);
		}
	}

	render() {
		const { titleText, titleIcon, headerContent, children, collapsible = false, className = null, subTitle = null, anchor = null, id = null, onTitleClick = null, compact = false, borderless = false, lazyMount = false } = this.props;
		let headerComponent;
		let _headerContent = headerContent;
		const headerStyle = compact ? styles.headerCompact : styles.header;
		const bodyStyle = compact ? styles.bodyCompact : styles.body;
		const panelStyle = borderless ? { border: "none", boxShadow: "none" } : {};
		const headerWrapperStyle = borderless ? { borderBottom: "none" } : {};
		if (!_headerContent) {
			let textComponent = (titleIcon) ? <span><FontAwesomeIcon icon={titleIcon} />&nbsp;&nbsp;{titleText}</span> : titleText;
			_headerContent = (
				<div className="row" style={headerStyle}>
					<div className="col-xs-12 vcenter">
						{textComponent}

					</div>
					{subTitle && !_.isEmpty(subTitle) && <div className="col-xs-12 vcenter"><small>{subTitle}</small></div>}
				</div>
			);
		}

		if (collapsible) {

			const addtlHeaderProps = {};

			if (id) {
				addtlHeaderProps.id = id;
			}

			let chevronDown = <span><Glyphicon glyph="chevron-down" /></span>;
			let chevronUp = <span><Glyphicon glyph="chevron-up" /></span>;
			_headerContent = (
				<div className="row-eq-height disable-select" style={Object.assign({}, styles.collapsible, compact ? styles.headerCompact : null)} onClick={this.handleToggle} {...addtlHeaderProps}>
					<div className="col-xs-8 vcenter">
						{headerContent ? _headerContent : (titleIcon) ? <span><FontAwesomeIcon icon={titleIcon} />&nbsp;&nbsp;{titleText}</span> : titleText}
						{subTitle && !_.isEmpty(subTitle) && <div><small>{subTitle}</small></div>}
					</div>
					<div className="col-xs-4 vcenter" style={styles.collapsibleButtonContainer}>
						<Button /*onClick={() => this.setState({ expanded: !this.state.expanded })}*/ bsSize="small">{this.state.expanded ? chevronUp : chevronDown}</Button>
					</div>
				</div>
			);
		}


		headerComponent = (
			<Panel.Heading className="header" style={Object.assign({}, onTitleClick ? { cursor: "pointer" } : {}, headerWrapperStyle)}>
				<div onClick={onTitleClick}>
					{_headerContent}
				</div>
			</Panel.Heading>
		);


		const shouldRenderBody = !lazyMount || !collapsible || this.state.expanded || this.state.hasEverExpanded;
		let body = shouldRenderBody ? <Panel.Body className="body" style={bodyStyle}>
			{children}
		</Panel.Body> : null;
		if (collapsible) {
			body = <SmoothCollapse allowOverflowWhenOpen={true} className="body-collapse" expanded={this.state.expanded}>{body}</SmoothCollapse>;
		}

		let additionalProps = {
			className: "ambifi-panel basic "
		};
		if (className) {
			additionalProps.className += className;
		}

		if (anchor) {
			additionalProps.id = anchor;
		}

		return (
			<Panel  {...additionalProps} style={panelStyle}>
				<ErrorBoundary>
					{headerComponent}
					{body}
				</ErrorBoundary>
			</Panel>
		);
	}
}

const styles = {
	body: { paddingLeft: "0.5em", paddingRight: 0 },
	bodyCompact: { padding: "6px 8px" },
	collapsible: { fontWeight: "bold", verticalAlign: "middle", cursor: "pointer" },
	collapsibleButtonContainer: { justifyContent: "flex-end" },
	header: { fontWeight: "bold" },
	headerCompact: { fontWeight: "bold", padding: "6px 8px" }
};

export default AmbifiBasicPanel;
